// assets/product-quick-buy.js
(function() {
  class QuickBuyManager {
    constructor() {
      this.init();
    }

    init() {
      this.setupEventListeners();
    }

    setupEventListeners() {
      // Listen for clicks on quick buy buttons
      document.addEventListener('click', (event) => {
        const quickBuyButton = event.target.closest('[aria-controls$="-drawer"], [aria-controls$="-popover"]');
        
        if (quickBuyButton) {
          const controlId = quickBuyButton.getAttribute('aria-controls');
          const drawer = document.getElementById(controlId);
          
          if (drawer && !drawer.hasAttribute('loaded')) {
            // Set loading state
            quickBuyButton.classList.add('is-loading');
            
            // Extract the product URL from the drawer's data attributes
            const productUrl = drawer.getAttribute('href');
            
            if (productUrl) {
              // Fetch the quick buy content
              this.loadQuickBuyContent(drawer, productUrl, () => {
                quickBuyButton.classList.remove('is-loading');
              });
            }
          }
        }
        
        // Handle thumbnail clicks
        const thumbnailItem = event.target.closest('.quick-buy-product__thumbnail-item');
        if (thumbnailItem) {
          event.preventDefault();
          this.handleThumbnailClick(thumbnailItem);
        }
      });
    }

    loadQuickBuyContent(container, productUrl, callback) {
      container.setAttribute('loaded', 'true');
      
      fetch(`${productUrl}?view=quick-buy`)
        .then(response => response.text())
        .then(html => {
          // Extract content from the template
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          const template = tempDiv.querySelector('#quick-buy-content');
          if (template) {
            container.innerHTML = template.innerHTML;
            
            // Initialize any needed functionality
            if (window.Shopify && window.Shopify.PaymentButton) {
              window.Shopify.PaymentButton.init();
            }
            
            // Initialize Variant Selectors
            this.initializeVariantSelectors(container);
            
            // Dispatch event when content is loaded
            container.dispatchEvent(new CustomEvent('quick-buy:loaded', {
              bubbles: true,
              detail: { drawer: container }
            }));
            
            if (typeof callback === 'function') {
              callback();
            }
          }
        })
        .catch(error => {
          console.error('Error loading quick buy content:', error);
          if (typeof callback === 'function') {
            callback();
          }
        });
    }

    handleThumbnailClick(thumbnail) {
      // Get the container
      const gallery = thumbnail.closest('.quick-buy-product__gallery');
      if (!gallery) return;
      
      // Update active state
      const thumbnails = gallery.querySelectorAll('.quick-buy-product__thumbnail-item');
      thumbnails.forEach(item => {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });
      
      thumbnail.classList.add('is-active');
      thumbnail.setAttribute('aria-current', 'true');
      
      // Get image data from data attributes
      const src = thumbnail.getAttribute('data-media-src');
      const srcset = thumbnail.getAttribute('data-media-srcset');
      const alt = thumbnail.getAttribute('data-media-alt') || '';
      
      // Update main image
      const mainImage = gallery.querySelector('.quick-buy-product__image');
      if (mainImage && src) {
        mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        mainImage.alt = alt;
      }
    }

    initializeVariantSelectors(container) {
      const variantSelectors = container.querySelectorAll('.product-form__option-selector');
      const productForm = container.querySelector('form[is="product-form"]');
      const productImage = container.querySelector('#quick-buy-main-image');
      
      if (!variantSelectors.length || !productForm || !productImage) return;
      
      // Get all radio inputs
      const inputs = container.querySelectorAll('input[type="radio"]');
      
      inputs.forEach(input => {
        input.addEventListener('change', () => {
          // Get selected variant
          const form = input.closest('form');
          const variantJSON = form.querySelector('[data-variant]');
          
          if (variantJSON) {
            try {
              const variant = JSON.parse(variantJSON.textContent);
              
              // Update image if variant has a featured image
              if (variant.featured_media) {
                productImage.src = variant.featured_media.preview_image.src;
                
                // Update active thumbnail
                const thumbnails = container.querySelectorAll('.quick-buy-product__thumbnail-item');
                thumbnails.forEach(thumbnail => {
                  const mediaId = thumbnail.getAttribute('data-media-id');
                  if (mediaId == variant.featured_media.id) {
                    this.handleThumbnailClick(thumbnail);
                  }
                });
              }
              
              // Update price
              const priceContainer = container.querySelector('.product-item-meta__price-list-container');
              if (priceContainer) {
                priceContainer.setAttribute('aria-live', 'polite');
                
                // You can implement price updates here if needed
              }
            } catch (e) {
              console.error('Error parsing variant JSON:', e);
            }
          }
        });
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new QuickBuyManager();
    });
  } else {
    new QuickBuyManager();
  }
})();